export default {
  from: 'de',
  select: 'Veja mais',
  deal: 'preço',
  deals: 'preços',
  total: '',
  total_fr: 'Total ',
  pp: 'pp',
}
